import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { ReactElement, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import { PROMO_CODE_DISCOUNT_TYPES } from '../../services/exports/Constants';
import useAppMethods from '../../hooks/utility/useAppMethods';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CheckmarkIcon from '../../assets/icons/CheckmarkIcon';
import CopyIcon from '../../assets/icons/actions/CopyIcon';
import Theme from '../Theme';

interface Props {
  className?: string;
}

export default function SavingsBanner(props: Props): ReactElement {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Banners:SavingsBanner' });

  const { className } = props;

  const { company } = useSelector((state: StoreInterface) => state.initialData);

  const { formatCurrency } = useAppMethods();

  const promoCode = company?.promo_codes?.length ? company.promo_codes[0] : null;

  const [copied, setCopied] = useState(null);

  const formattedDiscount = useMemo(() => {
    if (!promoCode) {
      return null;
    }

    return promoCode.discount_type === PROMO_CODE_DISCOUNT_TYPES.PERCENTAGE
      ? promoCode.components.find((component) => component.is_used === false).discount + '%'
      : formatCurrency(promoCode.discount, { trimInteger: true });
  }, [promoCode]);

  return (
    !!company?.has_savings_banner && (
      <div className={classnames('p-xs bg-brand-primary text-center text-white text-xs', className)}>
        {promoCode && company?.show_master_promo_code ? (
          <>
            <span className={classnames({ block: !copied })}>
              {t(copied ? 'text.copied_promo_code' : 'text.promo_code.title')}
            </span>
            {!copied ? (
              <span className="lg:text-sm">
                {t('text.promo_code.description', {
                  discount: formattedDiscount,
                  count: promoCode.components.length,
                })}{' '}
                <CopyToClipboard text={promoCode.code} onCopy={() => setCopied(true)}>
                  <span className="underline cursor-pointer font-medium">
                    {promoCode.code}{' '}
                    <CopyIcon className="h-4 w-4 my-auto ml-2xs inline" color={Theme.color.white.DEFAULT} />
                  </span>
                </CopyToClipboard>
              </span>
            ) : (
              <span>
                <CheckmarkIcon className="h-3 w-3 inline my-auto ml-2xs" color={Theme.color.white.DEFAULT} />
              </span>
            )}
          </>
        ) : (
          t('text.default')
        )}
      </div>
    )
  );
}
